module.exports = __webpack_public_path__ + "img/certificate.2a73fc58.jpg";